(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('Macro', Macro)
        .factory('MacroActions', MacroActions);

    Macro.$inject = ['$resource', 'DateUtils'];

    function Macro($resource, DateUtils) {
        var resourceUrl = 'api/macro/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                url: 'api/macros/:id',
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'create' : {method: 'PUT'},
            'delete' : {method: 'DELETE'},
            'update': {method: 'POST'},
            'queryGreengrass': {
                method: 'GET',
                url: 'api/macro/greengrass/:id',
                isArray: true
            },
            'queryAllGreengrass': {
                method: 'GET',
                url: 'api/macro/greengrass/all',
                isArray: true
            },
            'queryGreengrassByObjectType': {
                url: 'api/macro/greengrass/objectType/:objectTypeId/:fleetId',
                method: 'GET',
                isArray: true
            },
            'getMacroDetails': {
                method: 'GET',
                url: 'api/macro/greengrass/details/:macroId',
                params: { macroId: '@macroId' },
                isArray: true
            },
            'byObjectType': {
                url: 'api/macro/objectType/:id/:fleet',
                method: 'GET',
                isArray: true
            },
            'updateGreengrassCommandsOrder': {
                method: 'POST',
                url: 'api/macro/greengrass/updateOrder/:macroId',
                params: {
                    macroId: '@macroId'
                }
            },
            'deleteGreengrassCommand': {
                method: 'DELETE',
                url: 'api/macro/greengrass/command/:commandId/:macroId',
                params: {
                    commandId: '@commandId',
                    macroId: '@macroId'
                }
            }
        });
    }

    MacroActions.$inject = ['$resource', 'DateUtils'];

    function MacroActions($resource, DateUtils) {
        var resourceUrl = 'api/macro-detail/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                url: 'api/macro-detail/:id',
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });
    }
})();
